import React from 'react';
import SpeedDial, { SpeedDialProps } from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { SpeedDialActionProps } from '@material-ui/lab/SpeedDialAction/SpeedDialAction';
import isTouchDevice from 'is-touch-device';

export interface SpeedDialsActions extends SpeedDialActionProps {
  key: string,
  title: string,
  onClick?: () => void,
}

interface SpeedDialsProps {
  direction: SpeedDialProps['direction'],
  actions: SpeedDialsActions[],
  icon?: React.ReactNode,
  hidden?: SpeedDialProps['hidden'],
}

export default function SpeedDials(props:SpeedDialsProps) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const isTouch = typeof isTouchDevice() === 'boolean' && isTouchDevice() === true;

  return (
    <SpeedDial
      ariaLabel="SpeedDial"
      hidden={props.hidden}
      icon={props.icon ? props.icon : <SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction={props.direction || 'up'}
    >
      {props.actions.map((action) => (
        <SpeedDialAction
          key={action.key}
          icon={action.icon}
          title={action.title}
          tooltipTitle={action.title}
          tooltipOpen={isTouch}
          onClick={() => {
            handleClose();
            if (action.onClick) action.onClick();
          }}
        />
      ))}
    </SpeedDial>
  );
}
